import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M10.83 2.22a19.989 19.989 0 0 0-4.973 3.637 19.986 19.986 0 0 0-3.636 4.972l12.86 14.09 14.09 12.86a19.99 19.99 0 0 0 4.972-3.636 19.988 19.988 0 0 0 3.636-4.973l-12.86-14.09L10.83 2.22Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M34.143 34.143a20.118 20.118 0 0 0 2.246-2.674L8.53 3.611a20.118 20.118 0 0 0-4.92 4.92l27.86 27.858a20.127 20.127 0 0 0 2.673-2.246Z"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M5.857 34.143c6.31 6.31 15.786 7.52 23.313 3.636L2.22 10.829c-3.884 7.527-2.672 17.004 3.637 23.314ZM34.143 5.857c-6.31-6.31-15.787-7.52-23.314-3.636l26.95 26.95c3.885-7.527 2.674-17.004-3.636-23.314Z"
}, null, -1), d = [
  n,
  c,
  a
];
function s(i, r) {
  return e(), l("svg", o, [...d]);
}
const h = { render: s };
export {
  h as default,
  s as render
};
